export const styles = (theme) => ({
    paper: {
        padding: '12px',
        backgroundColor: "#F0F0F0",
        marginBottom: "20px",
    },
    toggleButton: {
        color: "black",
        "&.Mui-selected": {
            color: "black",
            borderColor: "#009",
            backgroundColor: "transparent",
        },
    },
    sectionInput: {
        minWidth: "200px",
        margin: "1rem 0",
        "& Button": {
            display: "block",
            width: "100%",
            padding: ".24706rem .42353rem",
            minHeight: "2.88235rem",
            textTransform: "none",
            fontWeight: "bold",
        },
    },
    buttonGroup: {
        width: "100%",
    }
});
